import styled from 'styled-components';
import mediaQuery from 'styles/mediaQuery';

export const AutomatedReviewLogsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 40px;

  .actions-container {
    align-self: end;
    display: flex;
    flex-direction: row;
    gap: 15px;

    .search-field {
      margin-bottom: 0;

      > div {
        padding: 0;
      }

      input[role='combobox'] {
        width: 160px;
      }
    }

    ${mediaQuery.xs} {
      width: 100%;

      .search-field {
        flex: 1;

        input[role='combobox'] {
          width: 100%;
        }
      }
    }
  }

  .actions-filter-form-buttons {
    border: none;
  }
`;
